export const IMAGE_TYPES = ['.png', '.jpg', '.jpeg', '.svg'];

export const GIF_TYPE = '.gif';

export const VISUAL_MEDIA_TYPES = [...IMAGE_TYPES, GIF_TYPE];

export const EMAIL_IMAGE_TYPES = ['.png', '.jpg', '.jpeg', '.svg'];

export const MAX_IMAGE_SIZE_BYTES = 5242880; // 5 MB

export const MAX_IMAGE_SIZE_BYTES_MB = MAX_IMAGE_SIZE_BYTES / 1024 / 1024;

export const fileRejectionErrorCode = {
  fileTooLarge: 'file-too-large',
  fileTooSmall: 'file-too-small',
  tooManyFiles: 'too-many-files',
  fileInvalidType: 'file-invalid-type',
};

export const IFRAME_TIMEOUT_MS = 3000;
